import React from 'react'

const PlacesFrame = props => <div className="places-frame">{props.children}</div>

export default PlacesFrame